import { Injectable } from '@angular/core';
import { createStore } from '@ngneat/elf';
import { selectEntity, upsertEntitiesById, withEntities } from '@ngneat/elf-entities';
import { createRequestsCacheOperator, updateRequestCache, withRequestsCache } from '@ngneat/elf-requests';
import { Observable } from 'rxjs';
import { DocumentStoreInitI } from '../models/folder';

interface DocumentStoreInitStateI {
    userUuid: string;
    documentStoreInit: DocumentStoreInitI;
}

const store = createStore(
    { name: 'documentStoreInit' },
    withEntities<DocumentStoreInitStateI, 'userUuid'>({ idKey: 'userUuid' }),
    withRequestsCache<`document-store-init-${string}`>()
);

export const skipWhileDocumentStoreInitCached = createRequestsCacheOperator(store);
export const CACHE_KEY_DOCUMENT_STORE_INIT = 'document-store-init';

@Injectable({ providedIn: 'root' })
export class DocumentStoreInitRepository {
    selectDocumentStoreInit$(userUuid: string): Observable<DocumentStoreInitI> {
        return store.pipe(selectEntity(userUuid, { pluck: 'documentStoreInit' }));
    }

    setDocumentStoreInit(userUuid: string, documentStoreInit: DocumentStoreInitI): void {
        store.update(
            updateRequestCache(`${CACHE_KEY_DOCUMENT_STORE_INIT}-${userUuid}`),
            upsertEntitiesById(userUuid, {
                creator: () => ({ userUuid, documentStoreInit }),
                updater: entity => ({ ...entity, documentStoreInit })
            })
        );
    }

    clearCacheOfUser(userUuid: string): void {
        store.update(updateRequestCache(`${CACHE_KEY_DOCUMENT_STORE_INIT}-${userUuid}`, { value: 'none' }));
    }
}
